import { render, staticRenderFns } from "./DsnRouterHistoryItem.vue?vue&type=template&id=63c6e3ff&"
import script from "./DsnRouterHistoryItem.vue?vue&type=script&lang=js&"
export * from "./DsnRouterHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./DsnRouterHistoryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports